function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '@guryou/html-components';
import { dateIsAfter, dateIsBetween, timeIsAfter, timeIsBetween } from '@guryou/utils';
import { printInputDate } from '@guryou/utils/build/dateTimeUtils';
import DateTimePicker from './DateTimePicker';
const DateRange = ({
  startDateFieldName,
  startTimeFieldName,
  endDateFieldName,
  endTimeFieldName,
  startValue,
  endValue,
  inline,
  onChange,
  wrapperXs,
  wrapperMargin,
  wrapperJustifyContent = 'space-around',
  startLabel,
  endLabel,
  xs,
  min,
  max,
  margin = 'normal',
  disableStart,
  disableEnd,
  notBetweenErrorMsg = null,
  z = true,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const [start, setStart] = useState(startValue);
  const [end, setEnd] = useState(endValue);
  const onStartChangeHandler = val => {
    setStart(val);
    onChange && onChange(val, end);
  };
  const onEndChangeHandler = val => {
    setEnd(val);
    onChange && onChange(start, val);
  };
  const handleStartFieldErrors = () => {
    if (startDateFieldName && start && end && dateIsAfter(printInputDate(start, z), printInputDate(end, z), true, z)) {
      return t('VALIDATIONS.endDateBeforeStartDate');
    }
    if (startTimeFieldName && !startDateFieldName && start && end && timeIsAfter(start, end, z)) {
      return t('VALIDATIONS.endTimeBeforeStartTime');
    }
    if (min && max && (startTimeFieldName && !timeIsBetween(start, min, max, z) || startDateFieldName && !dateIsBetween(start, min, max, z))) {
      return notBetweenErrorMsg || t('VALIDATIONS.breakDateNotBetween');
    }
    return null;
  };
  const handleEndFieldErrors = () => {
    if (min && max && (startTimeFieldName && !timeIsBetween(end, min, max, z) || startDateFieldName && !dateIsBetween(end, min, max, z))) {
      return notBetweenErrorMsg || t('VALIDATIONS.breakDateNotBetween');
    }
    return null;
  };
  const content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DateTimePicker, _extends({
    margin: margin,
    xs: xs || (inline ? 6 : 12),
    label: startLabel || t('GENERAL.from'),
    dateFieldName: startDateFieldName,
    timeFieldName: startTimeFieldName,
    value: start,
    onChange: onStartChangeHandler,
    errorMessage: handleStartFieldErrors(),
    disabled: disableStart,
    disableField: disableStart,
    z: z
  }, rest)), /*#__PURE__*/React.createElement(DateTimePicker, _extends({
    margin: margin,
    xs: xs || (inline ? 6 : 12),
    label: endLabel || t('GENERAL.to'),
    dateFieldName: endDateFieldName,
    timeFieldName: endTimeFieldName,
    value: end,
    onChange: onEndChangeHandler,
    errorMessage: handleEndFieldErrors(),
    disabled: disableEnd,
    disableField: disableEnd,
    z: z
  }, rest)));
  if (inline) {
    return /*#__PURE__*/React.createElement(FlexRow, {
      xs: wrapperXs,
      margin: wrapperMargin && wrapperMargin,
      alignItems: "baseline",
      justifyContent: wrapperJustifyContent
    }, content);
  }
  return content;
};
export default DateRange;